export enum FilterContainerType {
  TEXT = 1,
  SELECT,
  MULTISELECT,
  DATE_RANGE,
  DATE,
  NUMBER_RANGE,
  DATE_RANGE_MULTISELECT
}
